import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/Auth";
import themeReducer from "./slices/Theme";

export default configureStore({
  reducer: {
    auth: authReducer,
    theme: themeReducer,
  },
});
